import Immutable from 'seamless-immutable';
import _ from 'lodash';
import PageModel from './page-model';
import { baseCollection } from '../../common/collections';

/**
 * Takes an array of page objects and turns each object into a Model and the array into a Collection of the models
 * Doesn't work with array of already created Models
 * Most commonly used in a selector when reading an array of pages from the redux state tree and you want to turn them into a Collection
 * @param {Array} pages - an array of plain pages to wrap into a PageCollection
 */
function create(pages = []) {
  return Immutable(_.map(pages, PageModel.create));
}

/**
 * Transforms and array of backend page objects into a PageCollection
 * @param {Object[]} pages - backend formatted pages
 * @returns {Page[]}
 */
function deserialize(pages = []) {
  return Immutable(_.map(pages, PageModel.deserialize));
}

/**
 * Transforms a PageCollection into an array of backend page objects
 * @param {Page[]} pages
 * @returns {Object[]}
 */
function serialize(pages) {
  return _.map(pages, page => PageModel.serialize(page));
}

export default {
  ...baseCollection,
  create,
  deserialize,
  serialize,
};
